import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import "dayjs/locale/ru";
import "./App.css";
import LoginPage from "./modules/auth/login-page";
import { AlertProvider } from "./shared/alert-context";
import setupAxios from "./shared/axios/protected-axios-interceptor";
import PersistentDrawerLeft from "./shared/drawer/drawer";
import ErrorBoundary from "./shared/error/error-boundary";
import PrivateRoute from "./shared/private-route/private-route";
import { clearAuthentication } from "./shared/reducers/authentication";
import { getStore, persistor } from "./shared/store/store";
import { PersistGate } from "redux-persist/lib/integration/react";
import ResetPage from "./modules/auth/reset-page";
import { appTheme } from "./shared/theme/app-theme";
import DocumentTitle from "./shared/document-title";

const store = getStore();

const actions = bindActionCreators({ clearAuthentication }, store.dispatch);
setupAxios(() => actions.clearAuthentication);

function App() {
  return (
    <BrowserRouter>
      <DocumentTitle />
      <ThemeProvider theme={appTheme}>
        <AlertProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
            <ErrorBoundary>
              <Provider store={store}>
                <PersistGate persistor={persistor} loading={null}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Routes>
                      <Route path="login" element={<LoginPage />} />
                      <Route path="reset" element={<ResetPage />} />
                      <Route
                        path="*"
                        element={
                          <PrivateRoute>
                            <PersistentDrawerLeft />
                          </PrivateRoute>
                        }
                      />
                    </Routes>
                  </div>
                </PersistGate>
              </Provider>
            </ErrorBoundary>
          </LocalizationProvider>
        </AlertProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
